import * as React from "react";

import { Button } from "src/components/buttons";
import { Page, Spinner } from "src/components/common";

import CoreAPI from "src/core/CoreAPI";
import ReportAPI from "src/admin/report/ReportAPI";
import LocationAPI from "src/admin/Organization/Location/LocationAPI";

import FullReportTemplate from "src/admin/report/templates/v1/FullReportTemplate";

import PickListContext from "src/context/pickListContext";
import { notifyV1ReportsNotSupported } from "src/components/common/V1ReportsNotSupported";

interface IProps {
	location?: any;
	match: any;
}

interface IState {
	report: ReportNecessaryInfoDTO;
	coreTestResult: CoreTestResultDTO;
	coreErrorEntries: CoreErrorEntryDTO[];
	coreEvaluatorName: string;
	reportSetting: ReportSettingDTO;
	clientInfo: ClientDTO;
	locations: LocationDTO[];
	vitalsTestResult: VitalsTestResultDTO;
	vitalsToplots: VitalsToplotsDTO;
	vitalsSubScores: VitalsSubScoresDTO;
	vitalsCompletedTasks: VitalsCompletedTasksDTO[];
	vitalsEvaluatorName: string;
	fileURL: string;
	showFileLink: boolean;
	isLoading: boolean;
}

const defaultReportSetting: ReportSettingDTO = {
	id: 0,
	// primaryColor: '#09324c',
	primaryColor: "transparent",
	secondaryColor: "transparent",
	// secondaryColor: '#e06f23',
	vitalsReplacementText: "VITALS",
	coreReplacementText: "CORE",
	excelerateReplacementText: "EXCELERATE",
	showLogo: true,
	logoUrl: "",
	disclaimer: "",
};

class DatasetReportTemplateContainer extends React.Component<IProps, IState> {
	public static contextType = PickListContext;

	constructor(props: any) {
		super(props);
		this.state = {
			report: {},
			clientInfo: {},
			reportSetting: {},
			locations: [],
			coreTestResult: {},
			coreErrorEntries: [],
			coreEvaluatorName: "",
			vitalsTestResult: {},
			vitalsToplots: {},
			vitalsSubScores: {},
			vitalsCompletedTasks: [],
			vitalsEvaluatorName: "",
			isLoading: false,
			fileURL: "",
			showFileLink: false,
		};
	}

	public componentDidMount() {
		this.loadTestResult();
	}

	public render() {
		if (this.state.isLoading) {
			return <Spinner size="full-page" />;
		}
		return (
			<Page title="Report">
				<div className="container-fluid">
					{this.renderFullTemplate()}
					<div className="d-flex flex-row-reverse no-print">
						<Button
							className="btn-primary mr-3 no-print"
							onClick={this.printPDF}
						>
							Print Report
						</Button>
						<Button
							className="btn-primary mr-3 no-print"
							onClick={this.generatePDF}
						>
							Generate PDF
						</Button>
					</div>
				</div>
			</Page>
		);
	}

	private loadTestResult = () => {
		const { organizationId, resultId, datasetId } = this.props.match.params;
		this.setState({ isLoading: true });
		ReportAPI.getClientSiteReport({ reportId: resultId })
			.then((res) =>
				this.setState({
					report: res,
				})
			)
			.then(() =>
				ReportAPI.getClientSiteReportSettings({ reportId: resultId }).then(
					(res) =>
						this.setState({
							reportSetting: res,
						})
				)
			)
			.then(() =>
				LocationAPI.getClientSiteOrganizationLocations(
					organizationId,
					datasetId
				)
			)
			.then((orgLocations) => this.setState({ locations: orgLocations }))
			.then(() => {
				if (this.state.report.coreTestResultId) {
					// don't refactor this method because it will check current user's permission and match userId with evaluatorId on back-end
					ReportAPI.clientSiteGetCoreTestForReport({
						datasetId,
						reportId: this.state.report.assessmentResultId,
						coreTestResultId: this.state.report.coreTestResultId,
					})
						.then((res) => this.setState({ coreTestResult: res }))
						.then(() =>
							CoreAPI.getClientSiteClientCoreErrorEntries({
								datasetId,
								coreTestResultId: this.state.report.coreTestResultId,
							})
						)
						.then((res) =>
							this.setState({ coreErrorEntries: res, isLoading: false })
						);
				}
			})
			.then(() => {
				if (this.state.report.vitalsTestResultId) {
					ReportAPI.clientSiteGetVitalsTestForReport({
						datasetId,
						reportId: this.state.report.assessmentResultId,
						vitalsTestResultId: this.state.report.vitalsTestResultId,
					})
						.then((res) => this.setState({ vitalsTestResult: res }))
						.then(() =>
							ReportAPI.clientSiteGetVitalsFactorsForReport({
								datasetId,
								reportId: this.state.report.assessmentResultId,
								vitalsTestResultId: this.state.report.vitalsTestResultId,
							})
						)
						.then((res) =>
							this.setState({
								vitalsSubScores: res.vitalsSubScores!,
								vitalsToplots: res.vitalsToplots!,
								vitalsCompletedTasks: res.vitalsCompletedTasks!,
								isLoading: false,
							})
						);
				}
			});
	};

	private generatePDF = async () => {
		// V1 (HTML-to-PDF) report generation was retired.
		notifyV1ReportsNotSupported();
	};

	private renderFullTemplate = () => {
		return (
			<Page>
				<FullReportTemplate
					report={this.state.report}
					reportSetting={this.state.reportSetting}
					locations={this.state.locations}
					coreTestResult={this.state.coreTestResult}
					coreErrorEntries={this.state.coreErrorEntries}
					vitalsTestResult={this.state.vitalsTestResult}
					vitalsToplots={this.state.vitalsToplots}
					vitalsSubScores={this.state.vitalsSubScores}
					vitalsCompletedTasks={this.state.vitalsCompletedTasks}
				/>
			</Page>
		);
	};

	private printPDF = () => {
		window.print();
	};
}

export default DatasetReportTemplateContainer;
